import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { listWorkGroups } from '../../api/workGroups.js'

function formatDate(value) {
  if (!value) return ''
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return String(value)
  return parsed.toLocaleString()
}

export default function WorkGroupsListPage() {
  const navigate = useNavigate()
  const [state, setState] = useState({ status: 'loading', data: [], error: null })

  function load() {
    setState((s) => ({ ...s, status: 'loading' }))
    listWorkGroups()
      .then((data) => setState({ status: 'ok', data, error: null }))
      .catch((error) => setState({ status: 'error', data: [], error }))
  }

  useEffect(() => { load() }, [])

  return (
    <div className="page">
      <div className="pageHeader">
        <div className="buttonGroup mlAuto">
          <Link to="/" className="button buttonGhost">Back</Link>
          <Link to="/work-groups/new" className="button buttonPrimary">Create</Link>
        </div>
      </div>

      <section className="card sectionCard">
        <div className="pageHeader pageHeaderTight">
          <div>
            <div className="cardTitle">Work Groups</div>
          </div>
        </div>

        {state.status === 'loading' ? (
          <p className="muted inlineMessage">Loading work groups...</p>
        ) : null}

        {state.status === 'error' ? (
          <pre className="codeBlock codeBlockError">{String(state.error?.message || state.error)}</pre>
        ) : null}

        {state.status === 'ok' && state.data.length === 0 ? (
          <p className="muted inlineMessage">No work groups yet.</p>
        ) : null}

        {state.status === 'ok' && state.data.length > 0 ? (
          <table className="table" aria-label="Work groups list">
            <thead>
              <tr>
                <th>Title</th>
                <th>Description</th>
                <th>Created</th>
                <th className="alignRight"></th>
              </tr>
            </thead>
            <tbody>
              {state.data.map((wg) => (
                <tr key={wg.id}>
                  <td>{wg.title ?? ''}</td>
                  <td>{wg.description ?? ''}</td>
                  <td>{formatDate(wg.created_at)}</td>
                  <td className="alignRight">
                    <span className="tableActions">
                      <button
                        type="button"
                        className="button buttonGhost"
                        onClick={() => navigate(`/work-groups/${wg.id}`)}
                      >
                        View
                      </button>
                      <button
                        type="button"
                        className="button buttonGhost buttonDanger"
                        disabled
                        aria-label="Delete (disabled)"
                      >
                        Delete
                      </button>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </section>
    </div>
  )
}
